import { isTrue } from '@/utils/Common/Booleans';
import { calculateFilterColor } from '@/utils/Common/ListingUtils';

const FACET_PRICE_CODE = 'price';
const FACET_COLOR_CODE = 'baseColor';
const FACET_PERCENTAGE_DISCOUNT_CODE = 'percentageDiscountValue';

const normalizePlpPlusFacets = facets => {
  if (!facets || facets.length <= 0) return { noFacets: true };

  const otherValues = [];
  const priceValues =
    facets.find(facet => facet.code === FACET_PRICE_CODE)?.values || [];

  facets
    .filter(facet => facet.code !== FACET_PRICE_CODE)
    .forEach(facet => {
      switch (facet.code) {
        case FACET_COLOR_CODE: {
          const colorValues = facet.values.map(value => {
            const { name, style } = calculateFilterColor(value.code);
            return { ...value, name, style };
          });
          otherValues.push(...colorValues);
          break;
        }
        case FACET_PERCENTAGE_DISCOUNT_CODE: {
          const percentageValues = facet.values.map(value => ({
            ...value,
            name: `${value.name}%`,
          }));
          otherValues.push(...percentageValues);
          break;
        }
        default:
          otherValues.push(
            ...facet.values
              .filter(value => value.code !== 'false') // remove false values, not required in the plp-plus layout
              .map(value => ({
                ...value,
                name: isTrue(value.code) ? facet.name : value.name, // when value.code eq true, print the facet name instead of the value name (we don't want to see 'true' as label)
              })),
          );
          break;
      }
    });

  return {
    noFacets: false,
    hasOtherValues: otherValues.length > 0,
    otherValues,
    hasPriceValues: priceValues.length > 0,
    priceValues,
  };
};

export default normalizePlpPlusFacets;
